import { render, staticRenderFns } from "./ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario.vue?vue&type=template&id=13478e3a"
import script from "./ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario.vue?vue&type=script&lang=js"
export * from "./ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario.vue?vue&type=script&lang=js"
import style0 from "./ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario.vue?vue&type=style&index=0&id=13478e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports